import { roleApi, rolesApi, usersApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} parameters
   */
  async initUserManagement({ commit, dispatch }, parameters) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchRoles'),
      dispatch('fetchUsers', parameters),
    ];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchRoles({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await rolesApi.requestList(token);
      commit('setRoles', response.data.roles);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {Object} parameters
   */
  async fetchUsers({ commit, rootGetters }, parameters) {
    const token = rootGetters['auth/token'];
    try {
      const response = await usersApi.requestList(token, parameters);
      commit('addUsers', response.data.users);
      commit('setPaging', response.data.pagination);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} parameters
   */
  async addUsers({ commit, dispatch }, parameters) {
    commit('setAdding', true);
    await dispatch('fetchUsers', parameters);
    commit('setAdding', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} parameters
   */
  async refreshUsers({ commit, dispatch }, parameters) {
    commit('setRefreshing', true);
    commit('setUsers', []);
    await dispatch('fetchUsers', parameters);
    commit('setRefreshing', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} user
   */
  setUserToUpdate({ commit }, user) {
    commit('setDetail', user);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {Object} data
   */
  async updateRole({ commit, dispatch, rootGetters }, { data, parameters }) {
    const token = rootGetters['auth/token'];
    commit('setHandling', true);
    try {
      await roleApi.requestUpdate(token, data);
      await dispatch('refreshUsers', parameters);
    }
    catch (error) {
      commit('setError', error);
    }
    finally {
      commit('setHandling', false);
    }
  },
};
